<div class="card" style="display: flex; flex-direction: column; height: 100%;">
  <!-- Static Header -->
  <div class="card-header"
       style="flex-shrink: 0; background: white; display: flex; justify-content: space-between; align-items: center; padding: 10px; border-bottom: 1px solid #ddd;">
    <span style="font-weight: 600; color: black; font-size: 14px;">Fill out site capital</span>
    <button class="btn btn-primary" (click)="triggerSubmit()">Save</button>
  </div>

  <!-- Scrollable Body -->
  <div class="card-body" >
    <app-form-setup id="addsites"
      [FromJson]="formConfig"
      (formEmitted)="submitform($event)"
      (formCheck)="formSubmit($event)"
      [submitForm]="callForForm">
    </app-form-setup>
  </div>
</div>
